<template>
	<div class="card" :class="classes">
		<slot />
		<div class="card__acoes">
			<slot name="acoes" />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		cinza: Boolean,
		flex: Boolean,
		sombra: Boolean,
		borda: Boolean
	},
	computed: {
		classes() {
			let classe = ''

			if (this.cinza) classe += 'card--cinza'

			if (this.flex) classe += ' card--flex'

			if (this.sombra) classe += ' card--sombra'

			if (this.borda) classe += ' card--borda'

			return classe
		},
	},
}
</script>

<style>
.card {
	background-color: var(--v-background-base);;
	border-radius: 1rem;
	padding: 1.5rem;
	overflow-y: auto;
	scrollbar-color: var(--v-primary-base) #d9d9d9;
	scrollbar-width: thin;
	width: 100%;
}

.card--cinza {
	background-color: #d9d9d9;
}

.card--flex {
	display: flex;
}

.card--sombra {
	/* box-shadow: 30px 30px 50px 0px #d9d9d9; */
	box-shadow: rgba(0, 0, 0, 0.25) 0px 3px 10px -5px;
}

.card__acoes {
	display: flex;
	gap: 1rem;
	box-sizing: border-box;
}

.card--borda{
	border: 2px solid #6d6767;
	background-color: white;
}
</style>